/**
 * NoWifiAI 2026-08-29 — what THIS BROWSER remembers about its own training.
 *
 * Two things the hub cannot give back, so the browser keeps them itself:
 *   1. the ACTIVE job — so a training in progress survives tab navigation
 *      and a reload instead of collapsing back to "Awaiting Prompt";
 *   2. the SEVEN-WORD RECOVERY KEY per job — the hub stores only a
 *      fingerprint and can never reproduce it. It exists in plaintext once,
 *      in the create response, and lands here. Same trust level as the
 *      claim that already sits in localStorage: whoever holds this browser
 *      holds the library.
 */
const ACTIVE = "experts_active_job";
const KEY = (id) => `experts_recovery_key:${id}`;

export function rememberJob(job_id, recovery_key) {
  if (job_id) localStorage.setItem(ACTIVE, job_id);
  if (job_id && recovery_key) localStorage.setItem(KEY(job_id), recovery_key);
}
export function activeJob() { return localStorage.getItem(ACTIVE) || null; }
export function clearActive(job_id) {
  if (!job_id || localStorage.getItem(ACTIVE) === job_id) localStorage.removeItem(ACTIVE);
}
export function recoveryKey(job_id) { return job_id ? localStorage.getItem(KEY(job_id)) : null; }

export const LIVE = ["quoted", "awaiting_payment", "queued", "running", "packaging"];
export const isLive = (state) => LIVE.includes(state);

/**
 * 2026-10-27 (Dog: "the website is stuck" — a checkout opened 30 days earlier and never
 * paid still showed "[Training] … Waiting for payment" on every page). A job that is
 * still waiting for payment two hours after it was made is an abandoned checkout, not a
 * training: nothing was charged and nothing will run. It no longer counts as live, and
 * the progress page says so plainly with a way to start again.
 */
const UNPAID = ["quoted", "awaiting_payment"];
const ABANDON_AFTER_MS = 2 * 60 * 60 * 1000;
export const isUnpaid = (job) => !!job && UNPAID.includes(job.state);
export function isAbandoned(job) {
  if (!isUnpaid(job)) return false;
  const at = job.created_at ? Date.parse(job.created_at) : NaN;
  return Number.isFinite(at) && Date.now() - at > ABANDON_AFTER_MS;
}
/** Live AND not an abandoned checkout — what the strip and the home page follow. */
export const isActive = (job) => !!job && isLive(job.state) && !isAbandoned(job);
export function forgetJob(job_id) {
  clearActive(job_id);
  try { localStorage.removeItem(KEY(job_id)); } catch (_) { /* private mode */ }
}
